<template>
  <div class="manage">
    <el-dialog width="20%" :title="operateType === 'add' ? '新增回款明细' : '修改回款明细'" :visible.sync="isShow" :close-on-click-modal="false">
      <collection-form :collectionForm="collectionForm" ref="collectionForm"></collection-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('collectionForm')">保 存</el-button>
      </div>
    </el-dialog>
    <div class="manage-header">
      <el-button type="primary" @click="addCollection">+ 新增</el-button>
      <common-form inline :formLabel="formLabel" :form="searchFrom">
        <el-button type="primary">搜索</el-button>
      </common-form>
    </div>

    <common-table
      :tableData="tableData"
      :config="config"
      :usertype="usertype"
      @getSelectedRows="getSelectedRows"
      @changePage="getList"
      @edit="editCollection"
      @del="delCollection"
    ></common-table>
  </div>
</template>

<script>
import CommonForm from '../../components/CommonForm'
import CommonTable from './CollectionTable'
import CollectionForm from './CollectionForm'
// import Cookie from 'js-cookie'
import utils from '../../assets/js/utils'
export default {
  components: {
    CommonForm,
    CommonTable,
    CollectionForm
  },
  data() {
    return {
      isShow: false,
      operateType: 'add',
      tableData: [],
      usertype: '',
      user_realname: '',

      config: {
        page: 1,
        total: 30,
        loading: false
      },

      collectionForm: {
        id: '',
        contract: '',
        contract_name: '',
        collection_date: '',
        collection_amount: '',
        added_person: '',
        added_person_time: '',
        remark: ''
      },

      searchFrom: {
        keyword: ''
      },
      formLabel: [
        {
          model: 'keyword',
          label: ''
        }
      ]
    }
  },

  methods: {
    // 获取回款明细列表
    getList(name = '') {
      //获取当前用户信息：姓名，用户类型
      let user = utils.getUserCookie()
      this.usertype = user.user_type
      this.user_realname = user.name
      console.log('usertype:', this.usertype)
      console.log('user_realname:', this.user_realname)
      this.config.loading = true
      const api = '/getCollections/'
      this.$axios
        .get(api, {
          params: {
            page: this.config.page,
            name
          }
        })
        .then(res => {
          this.tableData = res.data.map(item => {
            item.contract_view = item.contract_id + '\n' + item.contract_name
            item.added = item.added_person + '\n' + item.added_person_time
            return item
          })
          console.log('collection list:', res.data)
          this.config.total = res.count
          this.config.loading = false
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    //增加回款明细
    addCollection() {
      this.collectionForm = {}
      this.operateType = 'add'
      this.isShow = true
    },

    //编辑回款明细
    editCollection(row) {
      console.log('row........', row)
      this.operateType = 'edit'
      this.isShow = true
      row.collection_amount = parseInt(row.collection_amount)

      this.collectionForm = row
      console.log('The new row:', this.collectionForm)
    },

    //删除回款明细
    delCollection(row) {
      this.$confirm('此操作将永久删除该回款明细, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let id = row.id
          this.$axios
            .get('/deleteCollection/', {
              params: {
                id
              }
            })
            .then(res => {
              console.log(res.data)
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    getSelectedRows(val) {
      console.log('Selected rows:', val)
    },
    submitForm(formName) {
      let form = this.$refs[formName]
      form.submitForm()
      if (form.isValidationOk) {
        if (this.operateType === 'edit') {
          //编辑当前回款明细
          console.log('The new row 2:', this.collectionForm)
          this.$axios.put('/updateCollection/', this.collectionForm).then(res => {
            console.log('response:', res.data)
            if (res.data.code === 1000) {
              this.$message({
                type: 'success',
                message: '更新回款明细成功!',
                duration: 2000
              })
              this.isShow = false
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.data.msg,
                duration: 2000
              })
            }
          })
        } else {
          //增加回款明细
          this.collectionForm.added_person = this.user_realname
          this.collectionForm.added_person_time = utils.getDateTime()
          console.log('add conllection:', this.collectionForm)
          this.$axios.post('/addCollection/', this.collectionForm).then(res => {
            console.log('response:', res.data)
            if (res.data.code === 1000) {
              this.$message({
                type: 'success',
                message: '增加回款明细成功!',
                duration: 2000
              })
              this.isShow = false
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.data.msg,
                duration: 2000
              })
            }
          })
        }
      } else {
        console.log('校验不通过！')
      }
    }
  },
  created() {
    this.getList()
  }
}
</script>
